// Comprehensive client-side search index for nav search.
// Added keywords/aliases for better matches (includes common variants and some typos).
const searchIndex = {
  en: [
  // Primary app routes (private)
  {
    id: "dashboard",
    type: "route",
    label: "Dashboard",
    path: "/dashboard",
    description: "Overview",
    keywords: ["home", "overview", "main", "panel", "dashboard", "tableau de bord"],
  },
  {
    id: "profile",
    type: "route",
    label: "Profile",
    path: "/profile",
    description: "Your profile & account",
    keywords: ["profile", "account", "my profile", "user", "profile settings"],
  },

  // Patients
  {
    id: "patients",
    type: "route",
    label: "Patients",
    path: "/patients",
    description: "Patient list & records",
    keywords: [
      "patient",
      "patients",
      "patient list",
      "patient records",
      "patient record",
      "patient profile",
      "records",
      "patie", // common partial/typo
    ],
  },
  {
    id: "add_patient",
    type: "route",
    label: "Add Patient",
    path: "/create-patient",
    description: "Create a new patient",
    keywords: [
      "add patient",
      "create patient",
      "new patient",
      "create new patient",
      "add new patient",
      "creat patient", // typo
      "creat new patient",
      "new patie", // partial typo
    ],
  },
  {
    id: "patient_profile",
    type: "route",
    label: "Patient Profile",
    path: "/patients/:id",
    description: "Open a specific patient (id)",
    keywords: ["patient profile", "open patient", "patient id", "open patient id"],
  },

  // Visits 
  {
    id: "visits",
    type: "route",
    label: "Visits",
    path: "/visits",
    description: "Patient visits & encounters",
    keywords: ["visit", "visits", "encounter", "consultation", "visit list", "visit record", "visit profile"],
  },
  {
    id: "add_visit",
    type: "route",
    label: "Add Visit",
    path: "/create-visit",
    description: "Create a new visit / encounter",
    keywords: ["add visit", "create visit", "new visit", "book visit", "create encounter"],
  },
  {
    id: "reception",
    type: "route",
    label: "Reception",
    path: "/reception",
    description: "Reception check-in flow",
    keywords: ["reception", "check in", "front desk", "walk in", "waiting room"],
  },
  {
    id: "visit_profile",
    type: "route",
    label: "Visit Profile",
    path: "/visits/:id",
    description: "Open a specific visit (id)",
    keywords: ["visit profile", "open visit", "visit id", "visit details"],
  },
 
  // Payments & Appointments
  {
    id: "payments",
    type: "route",
    label: "Payments",
    path: "/payments",
    description: "Payments & invoices",
    keywords: ["payment", "payments", "invoice", "billing", "invoices", "payments list"],
  },
  {
    id: "add_payment",
    type: "route",
    label: "Add Payment",
    path: "/create-payment",
    description: "Add a payment",
    keywords: ["add payment", "create payment", "new payment", "record payment"],
  },
  {
    id: "add_payment_direct",
    type: "route",
    label: "Add Payment (Direct)",
    path: "/create-payment/:patientId/:id",
    description: "Direct payment for patient",
    keywords: ["direct payment", "add payment direct", "payment for patient"],
  },

  {
    id: "appointments",
    type: "route",
    label: "Appointments",
    path: "/appointments",
    description: "Bookings & schedule",
    keywords: [
      "appointment",
      "appointments",
      "schedule",
      "calendar",
      "booking",
      "book appointment",
      "appointment list",
    ],
  },
  {
    id: "add_appointment",
    type: "route",
    label: "Add Appointment",
    path: "/add-appointment",
    description: "Create a new appointment",
    keywords: ["add appointment", "create appointment", "new appointment", "book appointment"],
  },

  // Staffs (doctor-only)
  {
    id: "staffs",
    type: "route",
    label: "Staffs",
    path: "/staffs",
    description: "Manage staff members",
    keywords: ["staff", "staffs", "employees", "team", "staff list", "team members"],
  },
  {
    id: "staff_profile",
    type: "route",
    label: "Staff Profile",
    path: "/staffs/:id",
    description: "Open a staff member (id)",
    keywords: ["staff profile", "open staff", "staff id", "employee profile"],
  },

  // Settings & other private pages
  {
    id: "settings",
    type: "route",
    label: "Settings",
    path: "/settings",
    description: "App settings & appearance",
    keywords: ["settings", "preferences", "configuration", "options", "appearance"],
  },
  {
    id: "medicaments",
    type: "route",
    label: "Medicaments",
    path: "/medicaments",
    description: "Manage medicaments",
    keywords: [
      "medicaments",
      "medications",
      "medicines",
      "drugs",
      "pharmacy",
      "prescriptions",
      "meds",
    ],
  },

  // Notifications / misc
  {
    id: "notifications",
    type: "route",
    label: "Notifications",
    path: "/notifications",
    description: "Your notifications",
    keywords: ["notification", "notifications", "alerts", "messages", "alerts center"],
  },

  // Public / fallback routes (helpful to have global)
  {
    id: "home",
    type: "route",
    label: "Home",
    path: "/",
    description: "Landing page",
    keywords: ["home", "landing", "welcome", "main"],
  },
  {
    id: "help",
    type: "route",
    label: "Help",
    path: "/help",
    description: "Help & docs",
    keywords: ["help", "docs", "documentation", "support", "faq"],
  },

  
],
  fr: [
    // French search entries (labels & keywords)
    {
      id: "dashboard",
      type: "route",
      label: "Tableau de bord",
      path: "/dashboard",
      description: "Aperçu",
      keywords: ["accueil", "aperçu", "tableau", "dashboard"],
    },
    { id: "profile", type: "route", label: "Profil", path: "/profile", description: "Votre profil", keywords: ["profil", "compte", "utilisateur"] },
    { id: "patients", type: "route", label: "Patients", path: "/patients", description: "Liste des patients", keywords: ["patient", "patients", "dossier patient"] },
    { id: "add_patient", type: "route", label: "Ajouter un patient", path: "/create-patient", description: "Créer un patient", keywords: ["ajouter patient", "nouveau patient", "créer patient"] },
    { id: "patient_profile", type: "route", label: "Profil patient", path: "/patients/:id", description: "Profil du patient", keywords: ["profil patient", "ouvrir patient"] },
    { id: "visits", type: "route", label: "Visites", path: "/visits", description: "Visites des patients", keywords: ["visite", "visites", "consultation"] },
    { id: "add_visit", type: "route", label: "Ajouter une visite", path: "/create-visit", description: "Créer une visite", keywords: ["ajouter visite", "nouvelle visite"] },
    { id: "reception", type: "route", label: "Reception", path: "/reception", description: "Flux d'accueil", keywords: ["reception", "accueil", "enregistrement", "sans rendez-vous"] },
    { id: "visit_profile", type: "route", label: "Profil de visite", path: "/visits/:id", description: "Détails de la visite", keywords: ["profil visite", "détails visite"] },
    { id: "payments", type: "route", label: "Paiements", path: "/payments", description: "Paiements & factures", keywords: ["paiement", "facture", "billing"] },
    { id: "appointments", type: "route", label: "Rendez-vous", path: "/appointments", description: "Agenda", keywords: ["rendez-vous", "agenda", "réservation"] },
    { id: "settings", type: "route", label: "Paramètres", path: "/settings", description: "Paramètres de l'application", keywords: ["paramètres", "préférences"] },
    { id: "home", type: "route", label: "Accueil", path: "/", description: "Page d'accueil", keywords: ["accueil", "welcome"] },
    { id: "help", type: "route", label: "Aide", path: "/help", description: "Aide & docs", keywords: ["aide", "documentation", "faq"] },
  ],
  ar: [
    // Arabic search entries (labels & keywords)
    {
      id: "dashboard",
      type: "route",
      label: "لوحة التحكم",
      path: "/dashboard",
      description: "نظرة عامة",
      keywords: ["الرئيسية", "نظرة عامة", "لوحة"],
    },
    { id: "profile", type: "route", label: "الملف الشخصي", path: "/profile", description: "ملفك الشخصي", keywords: ["الملف", "الحساب", "المستخدم"] },
    { id: "patients", type: "route", label: "المرضى", path: "/patients", description: "قائمة المرضى", keywords: ["مريض", "المرضى", "سجل المريض"] },
    { id: "add_patient", type: "route", label: "إضافة مريض", path: "/create-patient", description: "إنشاء مريض جديد", keywords: ["إضافة مريض", "مريض جديد"] },
    { id: "patient_profile", type: "route", label: "الملف المرضي", path: "/patients/:id", description: "ملف المريض", keywords: ["ملف المريض", "فتح مريض"] },
    { id: "visits", type: "route", label: "الزيارات", path: "/visits", description: "زيارات المرضى", keywords: ["زيارة", "زيارات", "استشارة"] },
    { id: "add_visit", type: "route", label: "إضافة زيارة", path: "/create-visit", description: "إنشاء زيارة", keywords: ["إضافة زيارة", "زيارة جديدة"] },
    { id: "reception", type: "route", label: "الاستقبال", path: "/reception", description: "مسار الاستقبال", keywords: ["الاستقبال", "تسجيل", "بدون موعد", "غرفة الانتظار"] },
    { id: "visit_profile", type: "route", label: "تفاصيل الزيارة", path: "/visits/:id", description: "تفاصيل الزيارة", keywords: ["تفاصيل الزيارة", "ملف الزيارة"] },
    { id: "payments", type: "route", label: "المدفوعات", path: "/payments", description: "المدفوعات والفواتير", keywords: ["دفع", "فواتير", "مدفوعات"] },
    { id: "appointments", type: "route", label: "المواعيد", path: "/appointments", description: "الحجوزات والجدول", keywords: ["موعد", "مواعيد", "حجز"] },
    { id: "settings", type: "route", label: "الإعدادات", path: "/settings", description: "إعدادات التطبيق", keywords: ["الإعدادات", "التفضيلات"] },
    { id: "home", type: "route", label: "الرئيسية", path: "/", description: "الصفحة الرئيسية", keywords: ["الصفحة الرئيسية", "الرئيسية"] },
    { id: "help", type: "route", label: "مساعدة", path: "/help", description: "مساعدة وموارد", keywords: ["مساعدة", "توثيق", "الأسئلة الشائعة"] },
  ],
}

export default searchIndex;